import { AffiliateApi } from "@/api/affiliates";
import { User } from "@/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { useNotify, useRedirect } from "react-admin";

export const useGetAffiliateUser = (id: User["id"]) => {
  const redirect = useRedirect();
  const notify = useNotify();

  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.AFFILIATE_USER, id],
    queryFn: () => AffiliateApi.getAffiliateUser({ id }),
    enabled: !!id,
  });

  if (isError) {
    notify(error, { type: "error" });
    redirect("list");
  }

  return { affiliate: data, isAffiliateLoading: isPending };
};
